
import { ArrowCircleRightSharp } from '@mui/icons-material';
import parse from 'html-react-parser';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useParams, useRouteMatch } from "react-router-dom";
import Scroll from 'react-scroll';
import ConnUrls from '../../Connections/ConnectURL';
import { CurrentPContext, MobiOrNotContext } from '../../ContextApi/context';
import ScrollingSaver from '../../DTechComp/ScrollingSaver';
import utilsCategurys from '../../_Utils/utilsCategurys';
import CategurysList from './CategurysList';
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';
import { Helmet } from 'react-helmet';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const CateguryPage = (props) => {



  const [currentPage, setCurrentPage] = useContext(CurrentPContext);

  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [loading, setLoading] = useState(true);
  const [catDataReady, setCatDataReady] = useState(false);
  const [allRestsOfCat, setAllRestsOfCat] = useState([]);
  const [cattxtOn, setCattxtOn] = useState(true);
  const [categorySchema, setCategorySchema] = useState("");
  const [breadcrumbSchema, setBreadcrumbSchema] = useState("");

  let { path, url } = useRouteMatch();

  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    // אין לאפס כאן את ההזמנה. האיפוס הגורף מחק גם את מספר ההזמנה שכבר
    // נוצרה בשרת, ולכן לקוח שחזר לתפריט אחרי שפתח תשלום קיבל הזמנה חדשה
    // עם מספר חדש — וכך הצטברו כפילויות בפאנל הניהול.
    // ההגנה מפני סל מעורב בין עסקים נעשית בכניסה לעמוד העסק
    // (RestaurantPage) וברגע ההוספה לסל (ProductItem*).

    props.shoTopStrp(false)
    getCatPage();
    setLoading(false);

  }, [])

  useEffect(() => {
    if (currentPage?.catHead) {
      createCategorySchema();
      createBreadcrumbSchema();
    }
  }, [currentPage])


  const getCatPage = async () => {
    let categuryPage = await utilsCategurys.getCateguryById(props.pageId);
    setCurrentPage({ ...categuryPage, pageTYp: "" });
    setCatDataReady(true);
  }

  const createCategorySchema = () => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": currentPage.catHead || currentPage.pageName,
      "description": currentPage.sEOdescription || currentPage.catText?.substring(0, 150) || "",
      "url": `${ConnUrls.siteDomainNam}/${currentPage.pageUrlFix}`,
      "image": currentPage.catImage ? `${ConnUrls.media(currentPage.catImage)}` : ""
    };
    setCategorySchema(JSON.stringify(schema));
  }

  const createBreadcrumbSchema = () => {
    const breadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "דף הבית",
          "item": ConnUrls.siteDomainNam
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": currentPage.catHead || currentPage.pageName,
          "item": `${ConnUrls.siteDomainNam}/${currentPage.pageUrlFix}`
        }
      ]
    };
    setBreadcrumbSchema(JSON.stringify(breadcrumb));
  }

  const goToBack = () => {
    history.goBack();

    // if (document.referrer.indexOf(window.location.host) === -1) {
    // }
    // else {
    //      history.push('/'); }
  }

  return (
    <div className="CateguryPage">
      {/* עד שנתוני הקטגוריה מגיעים - שכבת ההמתנה לפי מפת התמונות. אחר כך ממשיכה
          השכבה של CategurysList, עם אותה תמונה */}
      {!catDataReady ? <WaitImgOverlay item={{}} ready={false} /> :
        <>
          {(mobiOrNot) ?
            <div className={"headOnFixC SecondFont bold big"}>
              {currentPage.catHead}
              <div className={`backSdOnlyBtn`}>
                <ArrowCircleRightSharp onClick={() => goToBack()} />
              </div>
            </div> :
            ""}

          <br /><br /><br /><br />
          <div className={"fullWidth catTextBtn"}>

            {(mobiOrNot) ?
              <>
                <div className={"catTextBtnImg"} onClick={() => setCattxtOn(!cattxtOn)}>
                  <img src={`${ConnUrls.media(currentPage.catImage)}`} alt={currentPage.altTags || currentPage.pageName || ""} />
                </div>
                <div className={"ButtonMe"}
                  onClick={() => setCattxtOn(!cattxtOn)}>
                  {(!cattxtOn) ? "לפחות פרטים" : "לעוד פרטים"}
                </div>

              </>
              : <div className={"catTextBtnImg"} >
                <img src={`${ConnUrls.media(currentPage.catImage)}`} alt={currentPage.altTags || currentPage.pageName || ""} />
              </div>
            }
          </div>


          {(mobiOrNot) ?
            <div style={{ height: (!cattxtOn) ? `${(window.screen.width / currentPage.catText.length) * 0.5} ` : "" }}
              className={`catText ${!cattxtOn ? "CattxtOn" : "categuryTxt"}`}
              onClick={() => setCattxtOn(!cattxtOn)}>
              {parse(`${currentPage.catText}`)}
            </div>
            :
            <div className={`catText CattxtOn`}>
              {parse(`${currentPage.catText}`)}
            </div>
          }

          <div><CategurysList pageId={props.pageId} catPage={currentPage} /></div >

          {/* <Prompt
            message={(location, action) => {
              sessionStorage.setItem("scrol", document.scrollY)
              return true;
            }}
          /> */}
          < ScrollingSaver pagNam={"CateguryPage"} contentReady={catDataReady} />
        </>

      }
      <Helmet
        meta={[
          {
            property: "og:url", content: `${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.pageUrlFix)}`
          }
        ]}>
          <link rel="canonical" href={`${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.pageUrlFix)}`} />
          {categorySchema && <script type="application/ld+json">{categorySchema}</script>}
          {breadcrumbSchema && <script type="application/ld+json">{breadcrumbSchema}</script>}
      </Helmet>
    </div >
  );
}

export default CateguryPage;
